import { render } from "./OutdatedAdminEmails.vue?vue&type=template&id=d01e321c&scoped=true"
import script from "./OutdatedAdminEmails.vue?vue&type=script&lang=js"
export * from "./OutdatedAdminEmails.vue?vue&type=script&lang=js"

import "./OutdatedAdminEmails.vue?vue&type=style&index=0&id=d01e321c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d01e321c"]])

export default __exports__